import { defineStore } from "pinia";
import { ref } from "vue";

export const usePopupStackStore = defineStore("popupStack", () => {
  const stack = ref([]);

  const pushStack = (item) => {
    if (stack.value.includes(item)) {
      return;
    }
    stack.value.push(item);
  };

  return { stack, pushStack };
});
